import Timer from './Timer.vue';
export default Timer;
